<template>
  <div class="index-container-simple">
    <div class="index-context">
      <span class="title1">Welcome</span><br>
      <span class="title">欢迎进入{{VUE_APP_PLATFORM_NAME}}</span>
    </div>
  </div>
</template>

<script>
  export default {
    name: "IndexSimple",
    data() {
      return {}
    },
    created() {
    },
    mounted(){
    },
    methods: {
    }
  }
</script>

<style lang="less" scoped>
  .index-container-simple {
    padding-top: 12%;
    width: 100%;
    height: 800px;
    text-align: center;
    background-color: #fff;
  }
  .index-context {
    display: inline-block;
    width: 980px;
    height: 460px;
    background: #fff url(~@/assets/index-simple.png) no-repeat;
    background-position-x: 150px;
    background-size: 830px;
    color: #999;
    text-align: left;
    padding-top: 150px;

    .title1 {
      font-size: 30px;
    }
    .title {
      font-size: 26px;
    }
  }
</style>